import { Action, createReducer, on } from '@ngrx/store';

import { Catalog } from '../../interfaces/entity-interfaces';
import { clearCatalog, setCatalog, setCatalogPages, setCatalogs, setCatalogSaving } from './catalog.actions';

export interface CatalogState {
    list: Catalog[];
    current: Catalog | null;
    isSaving: boolean;
}

export const initialState: CatalogState = {
    list: [],
    current: null,
    isSaving: false,
};

export const catalogReducer = createReducer(
    initialState,
    on(setCatalogs, (state: CatalogState, action) => ({ ...state, list: action.payload })),
    on(setCatalog, (state: CatalogState, action) => ({ ...state, current: action.payload })),
    on(clearCatalog, (state: CatalogState) => ({ ...state, current: null })),
    on(setCatalogPages, (state: CatalogState, action) => ({
        ...state,
        current: state.current ? { ...state.current, pages: action.payload } : state.current,
    })),
    on(setCatalogSaving, (state: CatalogState, action) => ({ ...state, isSaving: action.payload }))
);

export function reducer(state: CatalogState, action: Action): CatalogState {
    return catalogReducer(state, action);
}
